export default __webpack_public_path__ + "static/media/boc-color.ffd0f711.svg";